import moment from "moment";
import Vue from "vue";
import store from "../store";

export let backgroundBus = new Vue();

let interval = null;
backgroundBus.$on("start", function(timeout) {
  if (interval) {
    clearInterval(interval);
  }
  if (!timeout) return;
  let qrExpiryTime = store.getters.getQrExpiryTime;
  if (!qrExpiryTime) {
    // set new qr expiry time with added timeout in minutes
    store.commit(
      "setQrExpiryTime",
      moment()
        .add(timeout, "minutes")
        .format()
    );
  }

  qrExpiryTime = store.getters.getQrExpiryTime;

  interval = setInterval(() => {
    if (moment().isAfter(moment(qrExpiryTime))) {
      // reset tableqr and qr expiry time
      store.commit("setQrExpiryTime", null);
      store.commit("setTableQR", "NO QR");

      // reset URL
      window.history.pushState("", "", "/");

      // restart background bus and add timeout
      backgroundBus.$emit("start", timeout);
    }
  }, 1000);
});

export default {
  install(Vue) {
    Vue.prototype.$background = backgroundBus;
  }
};
